import React from 'react'
import { easeInOutQuad } from '../utils/mathUtils'

export function useSmoothScroller(): ((element: HTMLDivElement, currentScroll: number, finalScroll: number) => void) {
  const safariScrollInterval = React.useRef<number | null>(null)

  const clearSafariScrollInterval = () => {
    if (safariScrollInterval.current !== null) {
      clearInterval(safariScrollInterval.current)
      safariScrollInterval.current = null
    }
  }

  return (element: HTMLDivElement, currentScroll: number, finalScroll: number) => {
    clearSafariScrollInterval()

    // safari - custom interval animation
    if (navigator.userAgent.toLowerCase().includes('safari')) {
      const duration = 300
      const startTime = new Date().getTime()
      const endTime = startTime + duration

      safariScrollInterval.current = window.setInterval(() => {
        const updateTime = new Date().getTime()
        const fraction = easeInOutQuad((Math.min(updateTime, endTime) - startTime) / duration)
        element.scrollLeft = currentScroll + (finalScroll - currentScroll) * fraction

        if (updateTime >= endTime) {
          if (safariScrollInterval.current !== null) {
            clearSafariScrollInterval()
            safariScrollInterval.current = null
          }
        }
      }, duration / 10)

      // default: native smooth scroll
    } else {
      element.scrollTo({
        left: finalScroll,
        behavior: 'smooth',
      })
    }
  }
}